/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Image from 'next/image';
import HorizontalScroll from '../shared/HorizontalScroll';
import playCircle from '../../../public/assets/playCircle.png';
import VideoPopup from '../shared/VideoPopup';
import { formatSecondsToDynamicTime } from '../../utils/helpers';
import { trackEvent } from '../../utils/analytics';
import EventNames from '../../utils/event-name-constants';
// import NoDataFound from '../shared/NoDataFound';
// import PageDataNotFound from '../shared/PageDataNotFound';

function CourseVideos({ courseVideoData, courseDetails }) {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentVideoUrl, setCurrentVideoUrl] = useState(null);
  const openModal = (videoUrl) => {
    trackEvent(EventNames.DEMO_CLASS_STARTED, {
      courseId: courseDetails?.id,
      courseName: courseDetails?.name,
      batchType: courseDetails?.type,
      screenName: 'courseDetail',
    });
    setCurrentVideoUrl(videoUrl);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setCurrentVideoUrl(null);
  };
    // convert duration
  // function changeDuration(totalSeconds) {
  //   const minutes = Math.floor(totalSeconds / 60); // Calculate minutes
  //   const seconds = totalSeconds % 60; // Calculate remaining seconds
  //   const totalTime = `${minutes}:${seconds}`;
  //   return totalTime;
  // }
  return (
    <>
      <div className="">
        <div className="lg:text-lg text-base font-semibold lg:mb-[18px] mb-4 text-black">See How We Teach</div>
        <HorizontalScroll className="scrollbar-hide">
          <div className="flex flex-shrink-0 gap-4 text-xs font-medium lg:font-semibold lg:text-base">
            {courseVideoData?.length > 0
            && courseVideoData.map((video, index) => (
              <div className={courseVideoData.length - 1 === index ? 'pr-4' : ''} key={video?.id}>
                <div className="border border-[#00000014] rounded-lg min-w-80 h-full bg-white overflow-hidden lg:w-[360px]">
                  <div className="flex relative ">
                    <Image
                      width={500}
                      height={500}
                      src={video?.thumbnail}
                      alt="teacher-banner"
                      className="self-start w-full h-36"
                    />
                    <div className="flex absolute top-0 left-0 w-100 h-100 bg-slate-700/40 min-w-full min-h-full items-center justify-center">
                      <Image width={48} height={48} src={playCircle} alt="play-button" className="w-12 absolute cursor-pointer" onClick={() => openModal(video?.url)} />
                      <span className="bg-black/90 self-end absolute right-1 bottom-1 text-white px-[6px] py-1 lg:text-sm text-xs font-medium rounded-sm">{formatSecondsToDynamicTime(video?.duration)}</span>
                    </div>
                  </div>
                  <span className="w-100 h-100 block lg:p-[18px] p-[10px] text-greyFont font-semibold line-clamp-2">{video?.title}</span>
                </div>
              </div>
            ))}

          </div>
        </HorizontalScroll>
        {isModalOpen && currentVideoUrl && (
        <VideoPopup videoUrl={currentVideoUrl} onClose={closeModal} />
        )}
      </div>
      {/* <hr className="border-2 my-[22px] border-[#E2E8F0] block xl:hidden  relative right-0 left-0" /> */}
    </>

  );
}
CourseVideos.propTypes = {
  courseVideoData: PropTypes.array.isRequired,
  courseDetails: PropTypes.object.isRequired,
};
export default CourseVideos;
